import React, { forwardRef } from 'react';
import { Slot } from '@radix-ui/react-slot';
import { cn } from '../../lib/utils';
import { motion, HTMLMotionProps } from 'framer-motion';
export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  asChild?: boolean;
  variant?: 'default' | 'outline' | 'ghost' | 'link';
  size?: 'default' | 'sm' | 'lg' | 'icon';
}
const Button = forwardRef<HTMLButtonElement, ButtonProps>(({
  className,
  variant = 'default',
  size = 'default',
  asChild = false,
  ...props
}, ref) => {
  const Comp = asChild ? Slot : 'button';
  // Base styles
  const baseStyles = 'inline-flex items-center justify-center whitespace-nowrap rounded-full text-sm font-medium ring-offset-white transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-950 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50';
  // Variants
  const variants = {
    default: 'bg-teal-600 text-slate-50 hover:bg-teal-600/90 shadow-sm hover:shadow-md transition-all duration-200',
    outline: 'border border-slate-200 bg-white hover:bg-slate-100 hover:text-slate-900',
    ghost: 'hover:bg-slate-100 hover:text-slate-900',
    link: 'text-teal-600 underline-offset-4 hover:underline'
  };
  // Sizes
  const sizes = {
    default: 'h-10 px-4 py-2',
    sm: 'h-9 rounded-md px-3',
    lg: 'h-12 rounded-full px-8 text-base',
    icon: 'h-10 w-10'
  };
  return <Comp className={cn(baseStyles, variants[variant], sizes[size], className)} ref={ref} {...props} data-id="element-154" />;
});
Button.displayName = 'Button';
export { Button };